module.exports = __webpack_public_path__ + "static/media/sidebar-collapse.22c811b3.svg";